import { Route, Routes } from 'react-router-dom'
import { RequireAuth } from '@/shared/auth/RequireAuth'
import { RequirePermission } from '@/shared/auth/RequirePermission'
import { AgentsPage } from '@/pages/AgentsPage'
import { AttendanceDevicesPage } from '@/pages/AttendanceDevicesPage'
import { AttendanceEmployeesPage } from '@/pages/AttendanceEmployeesPage'
import { AttendanceEventsPage } from '@/pages/AttendanceEventsPage'
import { AttendanceReportPage } from '@/pages/AttendanceReportPage'
import { AuditPage } from '@/pages/AuditPage'
import { LoginPage } from '@/pages/auth/LoginPage'
import { NoMembershipPage } from '@/pages/auth/NoMembershipPage'
import { TenantChoicePage } from '@/pages/auth/TenantChoicePage'
import { TotpPage } from '@/pages/auth/TotpPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { FinanceAccountsPage } from '@/pages/FinanceAccountsPage'
import { FinanceBranchReportPage } from '@/pages/FinanceBranchReportPage'
import { FinanceIncomeStatementPage } from '@/pages/FinanceIncomeStatementPage'
import { FinanceTrialBalancePage } from '@/pages/FinanceTrialBalancePage'
import { FinanceBalanceSheetPage } from '@/pages/FinanceBalanceSheetPage'
import { FinanceCashFlowPage } from '@/pages/FinanceCashFlowPage'
import { FinanceJournalPage } from '@/pages/FinanceJournalPage'
import { FinancePeriodsPage } from '@/pages/FinancePeriodsPage'
import { StakeholderDetailPage } from '@/pages/StakeholderDetailPage'
import { StakeholderDistributionsPage } from '@/pages/StakeholderDistributionsPage'
import { StakeholdersPage } from '@/pages/StakeholdersPage'
import { GrantsPage } from '@/pages/GrantsPage'
import { HrJobTitlesPage } from '@/pages/HrJobTitlesPage'
import { HrTurnoverPage } from '@/pages/HrTurnoverPage'
import { HrPayComponentsPage } from '@/pages/HrPayComponentsPage'
import { HrPersonDetailPage } from '@/pages/HrPersonDetailPage'
import { HrPersonsPage } from '@/pages/HrPersonsPage'
import { HrRatingCriteriaPage } from '@/pages/HrRatingCriteriaPage'
import { HrSalariesPage } from '@/pages/HrSalariesPage'
import { InventoryPage } from '@/pages/InventoryPage'
import { IpPoolsPage } from '@/pages/IpPoolsPage'
import { JobsPage } from '@/pages/JobsPage'
import { LeaveRequestsPage } from '@/pages/LeaveRequestsPage'
import { LeaveTypesPage } from '@/pages/LeaveTypesPage'
import { LedgerPage } from '@/pages/LedgerPage'
import { NasPage } from '@/pages/NasPage'
import { NetworkVispsPage } from '@/pages/NetworkVispsPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { NotifyMessagesPage } from '@/pages/NotifyMessagesPage'
import { NotifyQuietHoursPage } from '@/pages/NotifyQuietHoursPage'
import { NotifySubscriptionsPage } from '@/pages/NotifySubscriptionsPage'
import { NotifyTemplatesPage } from '@/pages/NotifyTemplatesPage'
import { OrgNodeTypesPage } from '@/pages/OrgNodeTypesPage'
import { OrgStructurePage } from '@/pages/OrgStructurePage'
import { TicketsPage } from '@/pages/TicketsPage'
import { LeadsPage } from '@/pages/LeadsPage'
import { InteractionsPage } from '@/pages/InteractionsPage'
import { PaymentCategoriesPage } from '@/pages/PaymentCategoriesPage'
import { TransferTypesPage } from '@/pages/TransferTypesPage'
import { ExpenseCategoriesPage } from '@/pages/ExpenseCategoriesPage'
import { CollectLimitsPage } from '@/pages/CollectLimitsPage'
import { PaymentProvidersPage } from '@/pages/PaymentProvidersPage'
import { PaymentsPage } from '@/pages/PaymentsPage'
import { CashdeskPage } from '@/pages/CashdeskPage'
import { BranchCashPage } from '@/pages/BranchCashPage'
import { CashTransfersPage } from '@/pages/CashTransfersPage'
import { DiscountApprovalsPage } from '@/pages/DiscountApprovalsPage'
import { DiscountPoliciesPage } from '@/pages/DiscountPoliciesPage'
import { FinanceBranchCashPage } from '@/pages/FinanceBranchCashPage'
import { FinanceDashboardPage } from '@/pages/FinanceDashboardPage'
import { InvoiceDetailPage } from '@/pages/InvoiceDetailPage'
import { InvoicesPage } from '@/pages/InvoicesPage'
import { PayrollRunDetailPage } from '@/pages/PayrollRunDetailPage'
import { PayrollRunsPage } from '@/pages/PayrollRunsPage'
import { PlansPage } from '@/pages/PlansPage'
import { PoliciesPage } from '@/pages/PoliciesPage'
import { ReportsPage } from '@/pages/ReportsPage'
import { RevenueByDimensionPage } from '@/pages/RevenueByDimensionPage'
import { SubscriberMovementPage } from '@/pages/SubscriberMovementPage'
import { SessionsPage } from '@/pages/SessionsPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { BrandingPage } from '@/pages/BrandingPage'
import { WhatsAppSettingsPage } from '@/pages/WhatsAppSettingsPage'
import { SitesPage } from '@/pages/SitesPage'
import { RegionsPage } from '@/pages/RegionsPage'
import { DistrictsPage } from '@/pages/DistrictsPage'
import { StockApprovalsPage } from '@/pages/StockApprovalsPage'
import { StockBalancesPage } from '@/pages/StockBalancesPage'
import { StockItemsPage } from '@/pages/StockItemsPage'
import { StockMovementsPage } from '@/pages/StockMovementsPage'
import { SubscriberDetailPage } from '@/pages/SubscriberDetailPage'
import { ContractsPage } from '@/pages/ContractsPage'
import { DeviceTypesPage } from '@/pages/DeviceTypesPage'
import { SubscribersPage } from '@/pages/SubscribersPage'
import { UiKitPage } from '@/pages/UiKitPage'
import { TenantsPage } from '@/pages/TenantsPage'
import { TransactionsPage } from '@/pages/TransactionsPage'
import { RolesPage } from '@/pages/RolesPage'
import { UsersPage } from '@/pages/UsersPage'
import { VenueCampaignsPage } from '@/pages/VenueCampaignsPage'
import { VenueDetailPage } from '@/pages/VenueDetailPage'
import { VenueJournalPage } from '@/pages/VenueJournalPage'
import { VenuesPage } from '@/pages/VenuesPage'
import { VoucherActivationsPage } from '@/pages/VoucherActivationsPage'
import { VoucherRegisterPage } from '@/pages/VoucherRegisterPage'
import { VoucherTransfersPage } from '@/pages/VoucherTransfersPage'
import { VoucherVispReportPage } from '@/pages/VoucherVispReportPage'
import { VouchersPage } from '@/pages/VouchersPage'
import { PurchaseReceivingPage } from '@/pages/PurchaseReceivingPage'
import { PurchasesPage } from '@/pages/PurchasesPage'
import { StockTransfersPage } from '@/pages/StockTransfersPage'
import { SupplierDetailPage } from '@/pages/SupplierDetailPage'
import { SuppliersPage } from '@/pages/SuppliersPage'
import { AppLayout } from './layout/AppLayout'

/**
 * Marshrutlar.
 *
 * Ikki qatlamli himoya:
 *   `RequireAuth`       — kirilganmi (va `me` yuklanganmi)
 *   `RequirePermission` — shu sahifaga huquq bormi
 *
 * Ikkinchisi navigatsiyadagi filtrni TAKRORLAYDI, va bu ataylab: menyuda
 * havola yo'q bo'lsa ham URL qo'lda kiritilishi yoki eski havola saqlangan
 * bo'lishi mumkin (04-ROLES.md §8).
 *
 * ⚠️ `PlaceholderPage` 2026-08-20 da O'CHIRILDI. Oxirgi joy `/payments`
 * edi: u "backendda mos controller yo'q (PSP)" deb belgilangan edi. Endi
 * `xsib-payments` da operator API'si bor (`/api/payments`,
 * `/api/payment-providers`), shuning uchun ikkala marshrut ham to'liq
 * sahifa va bo'sh o'rin qolmadi.
 *
 * `nas` ENDI placeholder EMAS: `xsib-platform` da `NasController` bor
 * (`nasApi.ts` sarlavhasidagi kontrakt), shuning uchun to'liq sahifa.
 *
 * `report` ham ENDI placeholder EMAS: `xsib-report` mikroservisi beshta
 * endpoint bilan ishlayapti va hammasi jonli tizimda tekshirilgan
 * (`reportsApi.ts`), shuning uchun to'liq `ReportsPage`.
 *
 * `audit` va `ledger` ESA boshqa holat: backend ularni AYNI PAYTDA
 * yozmoqda. Shuning uchun ular endi to'liq sahifa (`AuditPage`, `LedgerPage`)
 * — lekin endpoint hali javob bermasa, sahifaning O'ZI buni aniq aytadi
 * (`DataTable`ning xato holati / `LedgerPage`dagi izoh), placeholder emas.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Kirish oqimining oraliq bosqichlari — faqat navigatsiya holati
          (state) bilan yetib kelinadi, to'g'ridan-to'g'ri ochilsa
          `/login`ga qaytaradi. TARTIB: login → TOTP → (tenant tanlash). */}
      <Route path="/login/totp" element={<TotpPage />} />
      <Route path="/login/tenant" element={<TenantChoicePage />} />
      {/* Login+TOTP TO'G'RI, lekin faol a'zolik yo'q — bu holat state
          talab qilmaydi, shuning uchun to'g'ridan-to'g'ri ochilsa ham
          xavfsiz (ekranning o'zi izohiga qarang) */}
      <Route path="/login/no-access" element={<NoMembershipPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />

          <Route element={<RequirePermission permission="subscriber.read" />}>
            <Route path="subscribers" element={<SubscribersPage />} />
            <Route path="subscribers/:id" element={<SubscriberDetailPage />} />
            <Route path="subscribers/device-types" element={<DeviceTypesPage />} />
            <Route element={<RequirePermission permission="subscriber.contract.view" />}>
              <Route path="subscribers/contracts" element={<ContractsPage />} />
            </Route>
            <Route path="sessions" element={<SessionsPage />} />
          </Route>

          <Route element={<RequirePermission permission="plan.read" />}>
            <Route path="plans" element={<PlansPage />} />
            <Route path="policies" element={<PoliciesPage />} />
            {/* Reseller narxlari — `plan.read` bilan ko'rinadi, qo'yish
                esa `plan.price.set` bilan (sahifa ichida `Can`). */}
          </Route>

          {/* Voucher — 2-yo'nalish (mehmonxona/kafe). `plan.read` EMAS:
              `VoucherController` maxsus huquq kodiga ega emas, `subscriber.read`
              qarzga olingan (`voucherApi.ts` izohi) — ro'yxatni ko'rish uchun
              minimal huquq shu. Yaratish/kodlarni ko'rish/bekor qilish sahifa
              ichida `Can` bilan tegishli huquqqa (`subscriber.create/.delete`,
              `payment.create`) alohida bog'langan. */}
          <Route element={<RequirePermission permission="subscriber.read" />}>
            <Route path="vouchers" element={<VouchersPage />} />
            <Route path="vouchers/activations" element={<VoucherActivationsPage />} />
            <Route path="vouchers/register" element={<VoucherRegisterPage />} />
            <Route path="vouchers/transfers" element={<VoucherTransfersPage />} />
            <Route path="vouchers/visp-report" element={<VoucherVispReportPage />} />
            {/* Berilgan paketlar — `GrantController` mavjud
                `SUBSCRIBER_READ` huquqi ostida ishlaydi, yangi huquq
                o'ylab topilmadi (SHARTNOMA-2 §B). */}
            <Route path="grants" element={<GrantsPage />} />
          </Route>

          <Route element={<RequirePermission permission="venue.read" />}>
            <Route path="venues" element={<VenuesPage />} />
            <Route path="venues/journal" element={<VenueJournalPage />} />
            <Route path="venues/:id" element={<VenueDetailPage />} />
          </Route>

          {/*
            ⚠️ IKKALA huquq ham KERAK, va bu 2026-08-15 da o'zgardi (B11).

            Ilgari bu yerda faqat `campaign.manage` turardi va izohda
            «kampaniyalar `venue.read` emas, `campaign.manage` bilan
            cheklangan» deb yozilgandi. Server esa boshqacha ishlaydi:
            `CampaignServiceImpl.list` har qatorni `VenueScopeGuard`
            → `AccessGuard.scopeFilter(VENUE_READ)` dan o'tkazadi, va
            huquq bo'lmasa `denyAll()` keladi.

            O'LCHANDI (`CampaignPermissionTest`): faqat `campaign.manage`
            li foydalanuvchi uchta kampaniyadan BITTASINI ko'rardi
            (`venue_id IS NULL` bo'lganini) — HTTP 200, xato yo'q, log
            toza. Ya'ni ro'yxat bo'sh emas, CHALA edi, va bu bo'shdan
            ham yomonroq: operator «hammasi shu» deb o'qirdi.

            ⚠️ Nega server bo'shatilmadi: `VenueScopeGuard` — ob'ekt
            qatorlarining ko'rinishini hal qiladigan YAGONA joy;
            `campaign.manage` ga istisno ochish unga ikkinchi eshik
            qo'shardi. Server endi jim qolmaydi: `venue.read` bo'lmasa
            403 va tushunarli xabar qaytaradi.

            ⚠️ Ichma-ich ikki `RequirePermission` — ATAYLAB: komponent
            `canAny` semantikasida ishlaydi (ro'yxat = YOKI), ya'ni
            massiv berish VA emas, YOKI bo'lardi va nuqsonni
            YOMONLASHTIRARDI (`venue.read` yolg'iz ham sahifani
            ochardi).

            Seedlangan `VENUE_MANAGER` rolida ikkalasi ham bor — bugungi
            hech bir foydalanuvchi bu o'zgarishdan yo'qotmaydi.
          */}
          <Route element={<RequirePermission permission="campaign.manage" />}>
            <Route element={<RequirePermission permission="venue.read" />}>
              <Route path="venues/campaigns" element={<VenueCampaignsPage />} />
            </Route>
          </Route>

          <Route element={<RequirePermission permission="cash.receipt.create" />}>
            <Route path="cashdesk" element={<CashdeskPage />} />
          </Route>
          <Route element={<RequirePermission permission="cash.balance.view" />}>
            <Route path="cash/branches" element={<BranchCashPage />} />
            <Route path="cash/transfers" element={<CashTransfersPage />} />
          </Route>
          <Route element={<RequirePermission permission={['cash.discount.approve', 'cash.discount.apply']} />}>
            <Route path="cash/discounts" element={<DiscountApprovalsPage />} />
          </Route>
          <Route element={<RequirePermission permission="cash.discount.policy" />}>
            <Route path="cash/discount-policies" element={<DiscountPoliciesPage />} />
          </Route>
          <Route element={<RequirePermission permission="settings.update" />}>
            <Route path="cash/payment-categories" element={<PaymentCategoriesPage />} />
            <Route path="cash/transfer-types" element={<TransferTypesPage />} />
          </Route>
          <Route element={<RequirePermission permission="finance.account.write" />}>
            <Route path="cash/expense-categories" element={<ExpenseCategoriesPage />} />
          </Route>
          <Route element={<RequirePermission permission="cash.collect.limit.manage" />}>
            <Route path="cash/collect-limits" element={<CollectLimitsPage />} />
          </Route>
          <Route element={<RequirePermission permission="invoice.view" />}>
            <Route path="invoices" element={<InvoicesPage />} />
            <Route path="invoices/:id" element={<InvoiceDetailPage />} />
          </Route>
          <Route element={<RequirePermission permission="finance.dashboard.view" />}>
            <Route path="finance/dashboard" element={<FinanceDashboardPage />} />
          </Route>
          <Route element={<RequirePermission permission="cash.balance.view" />}>
            <Route path="finance/branch-cash" element={<FinanceBranchCashPage />} />
          </Route>

          <Route element={<RequirePermission permission="payment.read" />}>
            {/* Ilgari bu yerda `PlaceholderPage` turardi: `payments`
                modulida faqat PSP adapterlari bor edi (Click va kanonik
                protokol) — ular TASHQI tizim uchun. Endi operator
                ko'rinishi ham bor: `GET /api/payments`,
                `POST /api/payments/{id}/cancel` (xsib-payments `admin`) */}
            <Route path="payments" element={<PaymentsPage />} />
          </Route>

          {/* PSP sozlamalari — `payment.read` dan ALOHIDA huquq ostida:
              chegaralar va IP allowlist to'lovlarni to'xtatib qo'yishi
              mumkin, ya'ni ularni ko'rish "to'lovlarni ko'rish" bilan
              bir daraja emas (docs/04-ROLES.md §6) */}
          <Route element={<RequirePermission permission="psp.read" />}>
            <Route path="payment-providers" element={<PaymentProvidersPage />} />
          </Route>

          <Route element={<RequirePermission permission="ledger.read" />}>
            <Route path="ledger" element={<LedgerPage />} />
            {/* Tranzaksiyalar — `GET /api/ledger/entries`, AYNI huquq
                ostida (`@RequiresPermission(LEDGER_READ)`).

                ⚠️ `LedgerPage` NI ALMASHTIRMAYDI: u hisob markazli
                (qoldiq, qarz limiti, muvofiqlashtirish, agent balanslari,
                qo'lda tuzatish) va bu endpoint ularning birortasini ham
                bermaydi. Ikkalasi bir huquq ostida, chunki server ham
                shunday qo'riqlaydi. */}
            <Route path="transactions" element={<TransactionsPage />} />
          </Route>

          {/* Buxgalteriya — `xsib-finance` (QARORLAR.md §18, §20.7 7-qadam).

              ⚠️ `ledger.read` BILAN BIRLASHTIRILMAGAN va bu qarorning
              o'zagi: `ledger` — operatsion jurnal (abonent balansi,
              trafik), `finance` — buxgalteriya. Ikkinchisida butun
              tashkilotning foydasi va xarajati ko'rinadi, ya'ni maxfiylik
              darajasi boshqa.

              ⚠️ Kodlar `.view` bilan tugaydi, `.read` bilan EMAS:
              `identity.seed_system_roles()` `%.read` bilan tugagan
              huquqni "Kuzatuvchi" roliga O'Z-O'ZIDAN qo'shadi va moliya
              o'sha yo'l bilan hamma ko'radigan bo'lib qolardi
              (`shared/auth/permissions.ts` dagi batafsil izoh).

              ⚠️ `finance.account.write`, `.period.create` va `.period.close`
              marshrutda TEKSHIRILMAYDI — ular sahifa ICHIDAGI tugmalar
              huquqi (`Can` bilan). Ularni marshrutga qo'yish faqat
              ko'rish huquqi bor buxgalterga butun bo'limni yopib
              qo'yardi (`org`, `stock` va `hr` da aynan shu qaror).

              ⚠️ Jurnal sahifasi IKKI huquqdan biri bilan ochiladi:
              o'qish (`finance.period.view`) va xarajat kiritish
              (`finance.expense.write`) BOSHQA-BOSHQA odamlar bo'lishi
              mumkin. Sahifa ichida jadval o'qish huquqi yo'qligini ochiq
              aytadi. */}
          <Route element={<RequirePermission permission="finance.account.view" />}>
            <Route path="finance/accounts" element={<FinanceAccountsPage />} />
            {/* Filial jamlovchi hisoboti — `GET /api/finance/reports/branches`
                aynan `finance.account.view` bilan qo'riqlanadi
                (`FinanceReportController#branches`). Ilgari bu ma'lumot
                faqat eksport sifatida bor edi (`docs/11` §3). */}
            <Route path="finance/branches" element={<FinanceBranchReportPage />} />
            {/* Foyda hisoboti (P&L) va aylanma-qoldiq vedomosti —
                `GET /api/finance/reports/income-statement` va
                `/trial-balance`. Ikkalasi ham `FinanceReportController`
                da AYNAN `finance.account.view` bilan qo'riqlanadi, ya'ni
                marshrut huquqi endpoint huquqi bilan bir xil. Ilgari bu
                ma'lumot faqat eksport sifatida ochilardi (`docs/11` §6). */}
            <Route path="finance/income-statement" element={<FinanceIncomeStatementPage />} />
            <Route path="finance/trial-balance" element={<FinanceTrialBalancePage />} />
            <Route path="finance/balance-sheet" element={<FinanceBalanceSheetPage />} />
            <Route path="finance/cash-flow" element={<FinanceCashFlowPage />} />
          </Route>

          <Route element={<RequirePermission permission="finance.period.view" />}>
            <Route path="finance/periods" element={<FinancePeriodsPage />} />
          </Route>

          <Route
            element={
              <RequirePermission permission={['finance.period.view', 'finance.expense.write']} />
            }
          >
            <Route path="finance/journal" element={<FinanceJournalPage />} />
          </Route>

          <Route element={<RequirePermission permission="stakeholder.view" />}>
            <Route path="finance/stakeholders" element={<StakeholdersPage />} />
            <Route path="finance/stakeholders/:id" element={<StakeholderDetailPage />} />
            <Route path="finance/stakeholder-distributions" element={<StakeholderDistributionsPage />} />
          </Route>

          <Route element={<RequirePermission permission="agent.read" />}>
            <Route path="agents" element={<AgentsPage />} />
            {/* Reseller — alohida sahifa emas: u ayni daraxtdagi `kind`
                qiymati (RESELLER), shuning uchun Agentlarga yo'naltiriladi */}
            <Route path="resellers" element={<AgentsPage />} />
          </Route>

          <Route element={<RequirePermission permission="org.node.read" />}>
            <Route path="org/structure" element={<OrgStructurePage />} />
          </Route>

          <Route element={<RequirePermission permission="org.type.write" />}>
            <Route path="org/node-types" element={<OrgNodeTypesPage />} />
          </Route>

          <Route element={<RequirePermission permission="nas.read" />}>
            <Route path="nas" element={<NasPage />} />
          </Route>

          <Route element={<RequirePermission permission="network.visp.read" />}>
            <Route path="network/visps" element={<NetworkVispsPage />} />
          </Route>

          {/* Joylashuv reyestri va inventar — o'z huquqlariga bog'langan,
              `nas.read` ga BIRLASHTIRILMAGAN: qurilmalarni hisobga oluvchi
              xodim RADIUS klientlarini tahrirlashi shart emas (va aksincha) */}
          <Route element={<RequirePermission permission="site.read" />}>
            <Route path="sites" element={<SitesPage />} />
          </Route>

          {/* ⚠️ `geo.write` marshrutda TEKSHIRILMAYDI — u sahifa ICHIDAGI
              tugmalar huquqi (`Can`/`RowActions`). Marshrutga qo'yilsa
              faqat ko'rish huquqi bor operatorga reestr yopilardi. */}
          <Route element={<RequirePermission permission="geo.read" />}>
            <Route path="geo/regions" element={<RegionsPage />} />
            <Route path="geo/districts" element={<DistrictsPage />} />
          </Route>

          <Route element={<RequirePermission permission="inventory.equipment.read" />}>
            <Route path="inventory" element={<InventoryPage />} />
          </Route>

          {/* Ombor — `inventory` moduli kengaytmasi (QARORLAR.md §20.7,
              6-qadam). ⚠️ `inventory.equipment.read` DAN ALOHIDA huquq va
              bu ataylab: jihoz — seriya raqamli FIZIK NUSXA, ombordagi
              mol esa MIQDORLI tur. Ikki xil model, ikki xil ish va
              ko'pincha ikki xil odam (`QARORLAR.md` §20.8).

              ⚠️ `inventory.stock.write` va `.adjust` bu yerda
              TEKSHIRILMAYDI: ular sahifaga kirish emas, sahifa
              ICHIDAGI tugmalar huquqi (`Can` bilan). Ularni marshrutga
              qo'yish faqat ko'rish huquqi bor omborchiga butun bo'limni
              yopib qo'yardi — `org` va `attendance` da aynan shu qaror. */}
          <Route element={<RequirePermission permission="inventory.stock.read" />}>
            <Route path="stock/balances" element={<StockBalancesPage />} />
            <Route path="stock/items" element={<StockItemsPage />} />
            <Route path="stock/movements" element={<StockMovementsPage />} />
            <Route path="stock/transfers" element={<StockTransfersPage />} />
          </Route>
          <Route element={<RequirePermission permission="purchase.receive" />}>
            <Route path="stock/purchase-receiving" element={<PurchaseReceivingPage />} />
          </Route>
          <Route element={<RequirePermission permission="supplier.view" />}>
            <Route path="suppliers" element={<SuppliersPage />} />
            <Route path="suppliers/:id" element={<SupplierDetailPage />} />
            <Route path="purchases" element={<PurchasesPage />} />
          </Route>

          {/* Ikkinchi imzo — kutayotgan so'rovlar VA tashkilot chegarasi
              (`V202608151800`).

              ⚠️⚠️ IKKI HUQUQ, VA IKKINCHISI BOSHQA MODULDAN. Bu yagona
              ombor sahifasi `settings.update` bilan ham ochiladi, va bu
              ONGLI qaror, adashish emas:

                · ro'yxatni O'QISH  — `inventory.stock.read`
                · chegarani YOZISH  — `settings.update`
                  (`StockResource#updatePolicy`: omborchi o'z nazoratini
                  o'chira olmasin)

              O'lchandi (`V202608131600` + `identity.seed_system_roles()`):
              `inventory.stock.*` faqat `SUPERADMIN` va (`.read` bo'lgani
              uchun) `VIEWER` ga tushadi; `ADMIN` da esa `settings.update`
              BOR, ombor huquqlari YO'Q. Ya'ni bitta huquq talab qilinsa,
              chegarani o'zgartirishi kerak bo'lgan odam sahifani UMUMAN
              ocholmasdi va sabab huquq seedida qidirilardi.

              ⚠️ Sahifa ichida har blok O'Z huquqi bo'yicha qayta
              tekshiriladi va yetmaganda SABABI yoziladi — `canAny`
              "hammasi ochiq" degani EMAS. */}
          <Route
            element={
              <RequirePermission permission={['inventory.stock.read', 'settings.update']} />
            }
          >
            <Route path="stock/approvals" element={<StockApprovalsPage />} />
          </Route>

          {/* Kadrlar — `xsib-hr` (QARORLAR.md §20.5, §20.7 5-qadam).

              ⚠️ UCHALA SAHIFA ham `hr.person.read` bilan ochiladi.
              Lavozim katalogi uchun alohida o'qish kodi ATAYLAB
              ochilmagan (`JobTitleController` javadoc'i): katalog xodim
              kartochkasi va tayinlash oynasining bir qismi, ya'ni
              `hr.person.read` bori uni baribir ko'radi.

              ⚠️ `hr.person.write`, `hr.employment.write` va
              `hr.jobtitle.write` marshrutda TEKSHIRILMAYDI — sabab
              yuqoridagi bilan bir xil.

              ⚠️ `attendance` BILAN CHALKASHTIRMANG: §20.6 bo'yicha
              `hr.person` — OBRO'LI MANBA, `attendance.employee` esa
              qurilma ekrani uchun KESH. Ular alohida bo'limda qoladi. */}
          <Route element={<RequirePermission permission="hr.person.read" />}>
            <Route path="hr/persons" element={<HrPersonsPage />} />
            <Route path="hr/persons/:id" element={<HrPersonDetailPage />} />
            <Route path="hr/job-titles" element={<HrJobTitlesPage />} />
            {/* Kadrlar oqimi hisoboti — mijoz hujjatining «Employee
                turnover» bandi.

                ⚠️ AYNI huquq (`hr.person.read`) va bu ataylab: hisobot
                xodimlar RO.YXATIDAN kelib chiqadi va undan KAM ma.lumot
                beradi — sanoq, ism emas (`TurnoverServiceImpl`
                javadoc.i). Yangi huquq kodi ochilmagan. */}
            <Route path="hr/turnover" element={<HrTurnoverPage />} />
          </Route>

          {/* Maoshlar va ish haqi qismlari katalogi — `hr.salary.view`.

              ⚠️ `RequirePermission` ATAYLAB YO'Q va bu qolgan
              marshrutlardan farq qiladi. Sabab ikkita:

              1. Ikkala sahifa ham huquq yetmaganda `PermissionNotice`
                 chizadi — yetishmayotgan KOD xom holda, nusxa
                 olinadigan qilib. Umumiy «Ruxsat yo'q» sahifasi eng
                 kerakli savolga («qaysi huquqni so'ray?») javob
                 bermaydi, administrator esa rol konstruktorida aynan
                 shu nom bilan qidiradi.
              2. Marshrut qo'riqchisi qo'yilsa, o'sha shoxga hech
                 qachon kirilmasdi — ya'ni u O'LIK KOD bo'lardi va uni
                 tekshiradigan qorovul YOLG'ON YASHIL berardi
                 (`QARORLAR.md` §27.4 naqshi).

              ⚠️ Bu «himoya kamaydi» degani EMAS: ma'lumot baribir
              backend tekshiruvidan o'tmasdan kelmaydi (04-ROLES.md §8)
              va sahifa huquqsiz holda BIRORTA so'rov yubormaydi. */}
          <Route path="hr/salaries" element={<HrSalariesPage />} />
          <Route path="hr/pay-components" element={<HrPayComponentsPage />} />

          {/* Vedomost (ish haqi) — ALOHIDA huquq ostida.

              ⚠️ `hr.person.read` YETARLI EMAS va bu ataylab: maosh eng
              maxfiy ma'lumot va uning huquqlari hech bir tizim roliga
              o'z-o'zidan tushmaydi (`V202608150700` — birortasi ham
              `.read` bilan tugamaydi, ya'ni `seed_system_roles()`
              ularni umuman ko'rmaydi).

              ⚠️ `hr.payroll.run` va `hr.payroll.approve` marshrutda
              TEKSHIRILMAYDI: ular sahifa ICHIDAGI tugmalarni ochadi.
              Marshrutga qo'yilsa, faqat ko'rish huquqi bor buxgalter
              sahifani umuman ocha olmasdi. */}
          <Route element={<RequirePermission permission="hr.payroll.view" />}>
            <Route path="hr/payroll" element={<PayrollRunsPage />} />
            <Route path="hr/payroll/:id" element={<PayrollRunDetailPage />} />
          </Route>

          {/* Ta'til — so'rovlar va turlar katalogi.

              ⚠️ IKKALASI HAM `hr.leave.view` ostida: katalog ta'til
              so'rash oynasining bir qismi, ya'ni ko'rish huquqi bori
              uni baribir ko'radi (`hr/job-titles` bilan aynan bir xil
              mulohaza). Yozish huquqi (`hr.leavetype.write`) esa
              sahifa ichida tekshiriladi. */}
          <Route element={<RequirePermission permission="hr.leave.view" />}>
            <Route path="hr/leave" element={<LeaveRequestsPage />} />
            <Route path="hr/leave-types" element={<LeaveTypesPage />} />
          </Route>

          {/* Baholash mezonlari — ko'rish `hr.rating.view` bilan (baho oynasining bir qismi),
              yozish `hr.ratingcriterion.write` sahifa ichida. */}
          <Route element={<RequirePermission permission="hr.rating.view" />}>
            <Route path="hr/rating-criteria" element={<HrRatingCriteriaPage />} />
          </Route>

          {/* Davomat — yuzni tanish terminallari (`xsib-attendance`).

              ⚠️ TO'RT SAHIFA, TO'RT ALOHIDA HUQUQ. Ular bir modulda, lekin
              `attendance.read` kabi bitta umumiy ruxsatga BIRLASHTIRILMAGAN
              — chunki backendda ham alohida (`Permission` enum'idagi
              sakkizta kod). Amaliy sabab: hisobotni ko'radigan kadrlar
              xodimi terminal sozlamalariga tegmasligi kerak, tarmoq
              muhandisi esa teskarisi — qurilmani sozlaydi, lekin kim
              qachon kelganini bilishi shart emas.

              ⚠️ `attendance.door.open` va `attendance.device.sync` bu
              yerda TEKSHIRILMAYDI va tekshirilmasligi ham kerak: ular
              sahifaga kirish emas, sahifa ICHIDAGI bitta tugma huquqi
              (`Can` bilan). Ularni marshrutga qo'yish shu huquqi yo'q
              operatorga butun ro'yxatni yopib qo'yardi. */}
          <Route element={<RequirePermission permission="attendance.device.read" />}>
            <Route path="attendance/devices" element={<AttendanceDevicesPage />} />
          </Route>

          <Route element={<RequirePermission permission="attendance.employee.read" />}>
            <Route path="attendance/employees" element={<AttendanceEmployeesPage />} />
          </Route>

          <Route element={<RequirePermission permission="attendance.event.read" />}>
            <Route path="attendance/events" element={<AttendanceEventsPage />} />
          </Route>

          <Route element={<RequirePermission permission="attendance.report.read" />}>
            <Route path="attendance/report" element={<AttendanceReportPage />} />
          </Route>

          <Route element={<RequirePermission permission="report.read" />}>
            {/* ⚠️ ENDI PLACEHOLDER EMAS: `xsib-report` mikroservisi ishlayapti
                va beshta endpointi ham jonli tizimda tekshirilgan
                (`reportsApi.ts` sarlavhasidagi izoh). */}
            <Route path="reports" element={<ReportsPage />} />
            {/* Daromad kesimlarda va abonent bazasining harakati —
                `GET /api/reports/revenue/by/{dimension}` va
                `/api/reports/subscriber-movement`. Ikkalasi ham
                `RevenueResource`/`SubscriberReportResource` sinf
                darajasidagi `@RequiresPermission(REPORT_READ)` ostida,
                ya'ni marshrut huquqi endpoint huquqi bilan AYNI.
                Ilgari bu ma'lumot faqat eksport sifatida ochilardi
                (`docs/11` §5.1, §5.5). */}
            <Route path="reports/revenue-by" element={<RevenueByDimensionPage />} />
            <Route path="reports/subscriber-movement" element={<SubscriberMovementPage />} />
          </Route>

          <Route element={<RequirePermission permission="audit.read" />}>
            <Route path="audit" element={<AuditPage />} />
          </Route>

          {/* Fon vazifalari holati — `xsib-platform` `job` moduli
              (QARORLAR.md §20.1).

              ⚠️ `audit.read` BILAN BIRLASHTIRILMAGAN, garchi ikkala
              sahifa ham `Tizim` bo'limida va ikkalasi ham `platform`
              sxemasidan o'qisa ham. Ular BOSHQA savolga javob beradi:
              audit — ODAM nima qildi (tenant doirasida, RLS bilan), bu
              esa MEXANIZM yurdimi (butun platforma bo'ylab, tenant
              doirasisiz — `JobController` javadoc'i). Ikkinchisi
              tashkilotning ichki tuzilishini ko'rsatadi, ya'ni maxfiylik
              darajasi boshqa.

              ⚠️ Kod `.view` bilan tugaydi, `.read` bilan EMAS:
              `identity.seed_system_roles()` `%.read` bilan tugagan
              huquqni "Kuzatuvchi" roliga O'Z-O'ZIDAN qo'shadi
              (`shared/auth/permissions.ts` dagi batafsil izoh).

              ⚠️ Sahifada YOZISH amali umuman yo'q, shuning uchun ikkinchi
              huquq ham yo'q: backendda ham faqat ikkita `GET` bor va
              "hozir ishga tushir" tugmasi ATAYLAB qo'shilmagan. */}
          <Route element={<RequirePermission permission="job.run.view" />}>
            <Route path="jobs" element={<JobsPage />} />
          </Route>

          {/* Bildirishnomalar — `notify` moduli endi to'liq REST API'ga ega
              (15 endpoint, `notifyApi.ts`). Har sahifa o'z granular
              `notify.*.read` huquqiga bog'langan — `plans`/`policies` kabi
              bitta umumiy ruxsatga birlashtirilmagan, chunki backendda ham
              ular alohida (masalan operator faqat jurnalni ko'rishi, lekin
              shablonlarga tegmasligi mumkin). */}
          <Route element={<RequirePermission permission="notify.template.read" />}>
            <Route path="notify/templates" element={<NotifyTemplatesPage />} />
          </Route>
          <Route element={<RequirePermission permission="notify.subscription.read" />}>
            <Route path="notify/subscriptions" element={<NotifySubscriptionsPage />} />
          </Route>
          <Route element={<RequirePermission permission="notify.message.read" />}>
            <Route path="notify/messages" element={<NotifyMessagesPage />} />
          </Route>
          <Route element={<RequirePermission permission="notify.quiethours.read" />}>
            <Route path="notify/quiet-hours" element={<NotifyQuietHoursPage />} />
          </Route>

          {/* CRM — `xsib-crm` moduli (22 endpoint, 3 bo'lim).
              ⚠️ Har sahifa O'Z granular huquqi bilan, umumiy `crm.read`
              yo'q: backendda ham shunday. Sotuvchi lidlarni ko'radi,
              lekin murojaatlarga tegmasligi mumkin. */}
          {/* IP fondi — `inventory.ip.read`. Jihozlar bilan BITTA
              modulda, lekin ALOHIDA huquq ostida: manzil taqsimoti
              "shu IP kimda edi" degan savolga javob beradi va u jihoz
              ro'yxatidan ko'ra nozikroq ma'lumot. */}
          <Route element={<RequirePermission permission="inventory.ip.read" />}>
            <Route path="ip-pools" element={<IpPoolsPage />} />
          </Route>

          <Route element={<RequirePermission permission="crm.ticket.read" />}>
            <Route path="crm/tickets" element={<TicketsPage />} />
          </Route>
          <Route element={<RequirePermission permission="crm.lead.read" />}>
            <Route path="crm/leads" element={<LeadsPage />} />
          </Route>
          <Route element={<RequirePermission permission="crm.interaction.read" />}>
            <Route path="crm/interactions" element={<InteractionsPage />} />
          </Route>

          {/* ⚠️ `identity` MODULI TO'LIQ MAVJUD — bu marshrut endi placeholder
              EMAS. `UserResource`/`RoleResource` 12 ta endpoint beradi
              (`identityApi.ts` da ro'yxati). Ikkala huquqdan biri yetarli:
              faqat `role.read` bo'lsa sahifa ochiladi va foydalanuvchilar
              ro'yxati o'rniga sababi aniq yozilgan holat ko'rsatiladi. */}
          <Route element={<RequirePermission permission={['user.read', 'role.read']} />}>
            <Route path="users" element={<UsersPage />} />
          </Route>

          {/* Rollar ALOHIDA sahifa: "kim nima qila oladi" degan savol
              "kim ishlaydi" dan boshqa ish. Foydalanuvchilar sahifasi
              rolni BERADI, bu yerda esa rolning o'zi tuziladi. */}
          <Route element={<RequirePermission permission={['role.read']} />}>
            <Route path="roles" element={<RolesPage />} />
          </Route>

          {/* Tashkilotlar reyestri — PLATFORMA darajasidagi bo'lim.
              `settings.read` bilan BIRLASHTIRILMAGAN: sozlamalar "o'z
              tashkilotim", bu esa "platformadagi barcha tashkilotlar".

              ⚠️ Bu yerdagi `RequirePermission` YETARLI EMAS va bu
              ataylab: backend huquqdan TASHQARI GLOBAL ko'rinish
              doirasini ham talab qiladi (rollar dinamik, ya'ni tenant
              admini o'ziga `tenant.read` li rol yasab olishi mumkin
              edi). Ikkinchi shart sahifaning O'ZIDA tekshiriladi
              (`useIsPlatformOwner`) va sababi aniq yozilgan holat
              ko'rsatiladi — bo'sh jadval "tashkilot yo'q" degan
              noto'g'ri xulosaga olib kelardi. */}
          <Route element={<RequirePermission permission="tenant.read" />}>
            <Route path="tenants" element={<TenantsPage />} />
          </Route>

          <Route element={<RequirePermission permission="settings.read" />}>
            <Route path="settings" element={<SettingsPage />} />
            <Route path="settings/branding" element={<BrandingPage />} />
            {/* Proyeksiya `Tarmoq` guruhida: u baza va RADIUS jadvallari
                o'rtasidagi farqni ko'rsatadi, ya'ni sozlama emas, holat */}
          </Route>

          <Route element={<RequirePermission permission="notify.whatsapp.manage" />}>
            <Route path="settings/whatsapp" element={<WhatsAppSettingsPage />} />
          </Route>

          {/* Faqat dev: umumiy komponentlarni ko'z bilan tekshirish sahifasi.
              Prod build'da marshrut ham, sahifa ham qolmaydi. */}
          {import.meta.env.DEV && <Route path="dev/ui-kit" element={<UiKitPage />} />}

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
